<template>
  <div :class="$style.root">
    <p>{{ title }}</p>
    <div :class="$style.checkbox_list">
      <AtomsConsumerCheckbox v-for="item in localItems" :key="item.value" v-model="item.checked" :name="item.value">
        {{ item.key }}
      </AtomsConsumerCheckbox>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { CommonCheckBoxItem } from "~/types/review"

const props = defineProps<{
  title: string
  items: CommonCheckBoxItem[]
}>()

const emit = defineEmits<{
  (e: "update:items", v: CommonCheckBoxItem[]): void
}>()

const localItems = ref<CommonCheckBoxItem[]>([...props.items])

watch(
  () => localItems,
  () => emit("update:items", localItems.value),
  { deep: true },
)
</script>

<style scoped module lang="scss">
.root {
  .checkbox_list {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(7rem, 1fr));
    gap: 0.5rem 1rem;

    :global([class*="checkbox"]) {
      min-width: 5rem;
      max-width: 100%;
    }
  }
}
</style>
